export default "__VITE_ASSET__BSKuQ1hl__"